import { combineReducers } from "redux";
import loaderReducer from "./loaderReducer";
import authReducer from "./auth";
import settingReducer from "./setting";
import toastReducer from "./toast";
import accountReducer from "./account";
import orderSettingReducer from "./orderSettingReducer";
import menuReducer from "./menu";
import financeReducer from "./financeReducer";
import orderInvoicesReducer from "./orderInvoicesReducer";
const appReducer = combineReducers({
  loaderReducer,
  authReducer,
  settingReducer,
  toastReducer,
  accountReducer,
  orderSettingReducer,
  menuReducer,
  financeReducer,
  orderInvoicesReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};
export default rootReducer;
